import { Button, Result } from "antd";
import { useNavigate } from "react-router-dom";

const Notfound = () => {
  const navigate = useNavigate();

  const handleClicBack = () => {
    navigate("/home");
  };

  return (
    <div className="my-20 lg:my-40 text-center">
      <Result
        status="404"
        title="۴۰۴"
        subTitle="این صفحه در حال حاضر وجود ندارد"
        extra={
          <Button className="primary-button" onClick={handleClicBack}>
            بازگشت به خانه
          </Button>
        }
      />
    </div>
  );
};
export default Notfound;
